__turbopack_context__.v({
  "chevron": "Breadcrumb-module__r9A6Jq__chevron",
  "link": "Breadcrumb-module__r9A6Jq__link",
  "root": "Breadcrumb-module__r9A6Jq__root",
});
